import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const cretaecroprate = {
    label: "Create Crop Rate",
    pageLabel: "Create Crop Rate",
    starting: true,
    url: "cretaecroprate",
    pageType: "history",
    
    form: [
        {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Season",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Season",
            name: "Season",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Hangam",
            name: "",
            description: "Enter Hangam"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Hangam",
            name: "Hangam",
            description: "Enter Hangam"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Crop",
            name: "",
            description: "Enter Crop"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Crop",
            name: "Crop",
            description: "Enter Crop"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Land Type",
            name: "",
            description: "Enter Land Type"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Land Type",
            name: "Land_Type",
            description: "Enter Land Type"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "From Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "As on Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "fromdate",
            description: "Enter From to Date"
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "As on Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            name: "todate",
            description: "Enter From to Date"
          },
          
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Rate",
            name: "",
            description: "Enter Rate"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Rate",
            name: "Rate",
            description: "Enter Rate"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Period",
            name: "",
            description: "Enter Period"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Period",
            name: "Period",
            description: "Enter Period"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Expiry Date",
            name: "",
            description: ""
          },
          {
            inputType: "date",
            dateType: "ontype",
            isRequired: true,
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "As on Date",
            displayFormat: "DD/MM/YYYY",
            outputFormat: "YYYYMMDD",
            label: "",
            name: "expirydate",
            description: "Enter Expiry Date"
          }
    ]
  };
  export default cretaecroprate;